import React, { memo, useEffect } from "react";
import axios from "axios";
import { CRYPTOCOMPARE_KEY } from "../environment";
import {
  COINMARKETCAP_FAIL,
  COINMARKETCAP_SUCCESS,
  MIDGARDPOOL_FAIL,
  MIDGARDPOOL_SUCCESS,
  MIDGARDPOOL_REQUESTING,
  KEYSTORECONNECTION_FAIL,
  KEYSTORECONNECTION_REQUESTING,
  KEYSTORECONNECTION_SUCCESS,
  KEYSTORE_TRANSACTIONHISTORY_FAIL,
  KEYSTORE_TRANSACTIONHISTORY_REQUESTING,
  KEYSTORE_TRANSACTIONHISTORY_SUCCESS,
  TYPE,
  METAMASK,
  KEYSTORE,
  LOGOUT,
  LOGIN,
  MAINMODAL,
  SWAPPING_SUCCESS,
  SWAPPING_REQUEST,
  SWAPPING_FAILED,
  ADDLIQUIDITY_SUCCESS,
  GETLIQUIDITY_REQUEST,
  GETLIQUIDITY_SUCCESS,
} from "../../Redux/actions/types";
import {
  ETHERSCAN_URL,
  INBOUND_ADDRESSES,
  mainRoute,
  SERVER_URL_MAIN,
  VIEWBLOCK_URL,
} from "../../Routes/serverRoutes";
import { toast } from "react-toastify";
import browserRoute from "../../Routes/browserRoutes";
import { config } from "../../config";
import { TokenName } from "../../components/Helper/api-names";
import { MIDGARD_POOL } from "../../Routes/serverRoutes";
import Web3 from "web3";

import {
  generatePhrase,
  encryptToKeyStore,
  decryptFromKeystore,
} from "@xchainjs/xchain-crypto";
import { Network } from "@xchainjs/xchain-client";
import { Client as binanceClient } from "@xchainjs/xchain-binance";
import { Client as bitcoinClient } from "@xchainjs/xchain-bitcoin";
import { Client as thorchainClient } from "@xchainjs/xchain-thorchain";
// import { Client as ethereumClient } from "@xchainjs/xchain-ethereum/lib";
import { Client as litecoinClient } from "@xchainjs/xchain-litecoin";
import { Client as bitcoinCashClient } from "@xchainjs/xchain-bitcoincash";
import { EthUtilsService } from "../KeyStoreSwappingAsset/services/eth-utils.service";
import { MidgardService } from "../KeyStoreSwappingAsset/services/midgard.service";
import {
  TCAbi,
  TCRopstenAbi,
} from "../KeyStoreSwappingAsset/app/_abi/thorchain.abi";

import {
  AssetRuneNative,
  BaseAmount,
  assetAmount,
  assetToBase,
  baseAmount,
  AssetETH,
  AssetBNB,
  formatAssetAmountCurrency,
  assetFromString,
} from "@xchainjs/xchain-util";

import { environment } from "../environment";
import { ethers } from "ethers";
import CryptoJS from "crypto-js";
import { formatBaseAsAssetAmount } from "@xchainjs/xchain-util";
import { fr } from "date-fns/locale";
import { useSelector } from "react-redux";
require("dotenv").config();

const ethereumClient = require("@xchainjs/xchain-ethereum/lib");

const abi = environment.network === "testnet" ? TCRopstenAbi : TCAbi;

const contract = new ethers.Contract(
  "0xefA28233838f46a80AaaC8c309077a9ba70D123A",

  abi
);
const midgardService = new MidgardService();

const ethUtilsService = new EthUtilsService();

export function KeystoreWallet() {
  let userBinanceClient;
  let userBtcClient;
  let userThorchainClient;
  let userEthereumClient;
  let userLtcClient;
  let userbchClient;
  const alertToast = (error, message) => {
    if (!error) {
      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  async function serverEncryption(unencryptedData) {
    try {
      return CryptoJS.AES.encrypt(
        unencryptedData.toString(),
        "OptimusFox"
      ).toString();
    } catch (e) {
      return e.message;
    }
  }
  //connect

  async function gettingAssetName(asset) {
    let v = asset.split(".");
    return v[0];
  }

  this.connect = async function (
    dispatch,
    password,
    fileKeyStore,
    setConnectKeyStoreModal,
    setLoading,
    midgardPool
  ) {
    // const enable = await window.ethereum.enable();

    try {
      // localStorage.clear();
      dispatch({ type: LOGOUT });
      setLoading(true);
      let fileReader;
      const handleFileRead = async () => {
        try {
          const content = JSON.parse(fileReader.result);
          console.log(content);
          let res = await decryptFromKeystore(content, password);
          console.log("decryption=====>", res);
          // … do something with the 'content' …
          //Network is defined here for all the general networks
          let clients = {};
          let mainClients = [];
          let clientsObject = {};
          const network =
            environment.network === "testnet"
              ? Network.Testnet
              : Network.Mainnet;
          console.log("Enabled Network: ---------------> ", network);

          try {
            //Binance Address is getting from here
            userBinanceClient = new binanceClient({ network, phrase: res });
            console.log("here", userBinanceClient);
            let BinanceClientAddress = await userBinanceClient.getAddress();
            clients.Binance = userBinanceClient;
            console.log(
              "User Binance Client address: ---------------> ",
              BinanceClientAddress
            );

            const balanceBinance = await userBinanceClient.getBalance(
              BinanceClientAddress
            );
            console.log("balance of binance=====", balanceBinance);
            if (balanceBinance?.length > 0) {
              const transationResultOfBinanceClient =
                await userBinanceClient.getTransactions({
                  address: BinanceClientAddress,
                  limit: Infinity,
                });
              console.log(
                "Transaction Data of Binance CLient",
                transationResultOfBinanceClient
              );

              clients.Balance = balanceBinance;
              // clients.Transactions = transationResultOfBinanceClient;
              clients.Address = BinanceClientAddress;
              clients.Transactions = transationResultOfBinanceClient;
              mainClients.push({ ...clients });
              clientsObject.userBinanceClient = userBinanceClient;
            }
            // Transactions history of Binance Client getting here
          } catch (error) {
            console.log("error========", error);
          }

          //Bitcoin Client is set here
          try {
            userBtcClient = new bitcoinClient({
              network,
              phrase: res,
              sochainUrl: "https://sochain.com/api/v2",
              blockstreamUrl: "https://blockstream.info",
            });
            //Bitcoin Client is Address generating from here
            console.log("User Btc Client: ---------------> ", userBtcClient);
            let addressBtc = userBtcClient.getAddress();
            console.log("BTC Address: ---------------> ", addressBtc);
            //Balance of Bitcoin is getting from here
            // const providerBTC = await userBtcClient.getProvider();
            const balanceBtc = await userBtcClient.getBalance(addressBtc);
            console.log("balance Of BTCCSCS: ---------------> ", balanceBtc);
            console.log(
              "balance: ---------------> ",
              balanceBtc[0].amount.amount().c[0] /
                Math.pow(10, balanceBtc[0].amount.decimal)
            );

            //Transactions history of BTC Client getting here
            const transationResultOfBTCClient =
              await userBtcClient.getTransactions({
                address: addressBtc,
                limit: Infinity,
              });
            console.log(
              "Transaction Data of BTC CLient",
              transationResultOfBTCClient
            );
            clients.Address = addressBtc;
            clients.Balance = balanceBtc;
            clients.Transactions = transationResultOfBTCClient;
            mainClients.push({ ...clients });
            clientsObject.userBtcClient = userBtcClient;
          } catch (error) {
            console.log(error);
          }

          //Thorchain Client is set here
          let thorAddress;
          try {
            userThorchainClient = new thorchainClient({
              network,
              phrase: res,
            });
            console.log(
              "User Thorchain Client: ---------------> ",
              userThorchainClient
            );
            //Thorchain Address is generation from here
            thorAddress = await userThorchainClient.getAddress();
            console.log("THORChain Address: ---------------> ", thorAddress);
            //Balance of THORChain is getting from here
            const balanceThor = await userThorchainClient.getBalance(
              thorAddress
            );
            console.log("length====>>>", balanceThor.length);
            console.log("THORChain Balance: ---------------> ", balanceThor);
            //Transactions history of Thorchain Client getting here
            const transationResultOfTHORChain =
              await userThorchainClient.getTransactions({
                address: thorAddress,
                limit: Infinity,
              });
            console.log(
              "Transaction Data of THORChain CLient",
              transationResultOfTHORChain
            );
            clients.Address = thorAddress;
            clients.Balance = balanceThor;
            clients.Transactions = transationResultOfTHORChain;
            mainClients.push({ ...clients });
            clientsObject.userThorchainClient = userThorchainClient;
          } catch (error) {
            console.log(error);
          }
          // Ethereum CLinet is set here
          let addressEth;
          try {
            userEthereumClient = new ethereumClient.Client({
              network: network,
              phrase: res,
              etherscanApiKey: environment.etherscanKey,
              infuraCreds: { projectId: environment.infuraProjectId },
            });
            // //Ethereum Client Address is generation from here
            // console.log("User Ethereum Client: ---------------> ", userEthereumClient.getAddress());
            //Ethereum CLient Provider is printing here
            const provider = userEthereumClient.getProvider();
            console.log("Ethereum Provider: ---------------> ", provider);
            // //Ethereum Balance is getting from here
            clients.Ethereum = userEthereumClient;
            addressEth = userEthereumClient.getAddress();
            const ethBalance = await provider.getBalance(addressEth);
            console.log(
              "Ethereum Balance: ---------------> ",
              ethBalance.toString()
            );
            console.log("Ethereum Address: ---------------> ", addressEth);

            //Ethereum Client Balance is getting from here
            const balance1eth = await userEthereumClient.getBalance(addressEth);

            console.log(
              "Ethereum Client Balance: ---------------> ",
              balance1eth
            );

            //Start Tokens Implementation

            let check = await axios.get(
              `https://api.ethplorer.io/getAddressInfo/${addressEth}?apiKey=freekey`
            );

            if (check && check.data && check.data.tokens) {
              let ethTokens = check.data.tokens;
              let ethClient = {};
              ethTokens.map((d) => {
                let amountCheck = {
                  type: "BASE",
                  decimal: Number(d?.tokenInfo?.decimals),
                  amount: () => {
                    return {
                      c: [Number(d?.rawBalance), 1],
                    };
                  },
                };
                let asset = {
                  chain: "ETH",
                  symbol: d?.tokenInfo?.symbol,
                  ticker: d?.tokenInfo?.symbol,
                };
                ethClient.asset = asset;
                ethClient.amount = amountCheck;

                let newClient = { ...ethClient };
                balance1eth.push({ ...newClient });

                console.log("Getting Tokens=============>>>>", newClient);
              });
            }
            //END Tokens Implementation

            let balance = "";

            let b1 = balance1eth[0]?.amount.amount();
            for (let i = 0; i < b1.c.length; i++) {
              balance = balance.toString() + b1.c[i].toString();
            }
            console.log("balance ==========", balance);
            let amount = {
              type: "BASE",
              decimal: 18,
              amount: () => {
                return {
                  c: [Number(balance), 1],
                };
              },
            };
            balance1eth[0].amount = amount;

            //Transactions history of Ethereum Client getting here
            const transationResultOfEthereum =
              await userEthereumClient.getTransactions({
                address: addressEth,

                limit: Infinity,
              });

            console.log(
              "Transaction Data of Ethereum CLient",
              transationResultOfEthereum
            );
            clients.Address = addressEth;
            clients.Balance = balance1eth;
            clients.Transactions = transationResultOfEthereum;
            mainClients.push({ ...clients });
            clientsObject.userEthereumClient = userEthereumClient;
          } catch (error) {
            console.log(error);
          }
          //LTC Client is setup here
          try {
            userLtcClient = new litecoinClient({
              network,
              phrase: res,
            });
            // LTC Client Address generation is done here
            let addressLTC = userLtcClient.getAddress();
            console.log("User LTC Client: ---------------> ", addressLTC);
            //LTC Client Balance is getting from here
            const balanceLTC = await userLtcClient.getBalance(addressLTC);
            console.log("LTC Client Balance: ---------------> ", balanceLTC);
            //Transactions history of LTC Client getting here
            const transationResultOfLTC = await userLtcClient.getTransactions({
              address: addressLTC,
              limit: Infinity,
            });
            console.log(
              "Transaction Data of LTC CLient",
              transationResultOfLTC
            );
            clients.Address = addressLTC;
            clients.Balance = balanceLTC;
            clients.Transactions = transationResultOfLTC;
            mainClients.push({ ...clients });
            clientsObject.userLtcClient = userLtcClient;
          } catch (error) {
            console.log(error);
          }

          //BCH Client is setup here
          try {
            userbchClient = new bitcoinCashClient({ network, phrase: res });
            //BCH Client Address generation is done here
            let addressBCH = userbchClient.getAddress();
            console.log("User BCH Client: ---------------> ", addressBCH);
            //BCH Client Balance getting is done here
            const balanceBCH = await userbchClient.getBalance(addressBCH);
            console.log("BCH Client Balance: ---------------> ", balanceBCH);
            //Transaction History of BCH Client getting here
            const transationResultOfBCH = await userbchClient.getTransactions({
              address: addressBCH,
              limit: Infinity,
            });
            console.log(
              "Transaction Data of BCH CLient",
              transationResultOfBCH
            );
            clients.Address = addressBCH;
            clients.Balance = balanceBCH;
            clients.Transactions = transationResultOfBCH;
            mainClients.push({ ...clients });
            clientsObject.userbchClient = userbchClient;
          } catch (error) {
            console.log(error);
          }

          console.log("Clients===>>>", mainClients);
          // localStorage.setItem("isLoggedin", true);
          // localStorage.setItem(TYPE, KEYSTORE);
          // const EncryptedClients = await serverEncryption(
          //   // JSON.stringify(clients, getCircularReplacer())
          //   JSON.stringify(res)
          // );
          // console.log("Check====>>>", EncryptedClients);
          // localStorage.setItem("phrase", EncryptedClients);
          // let clientsDescryption = await serverDecryption(clientsEncryption);
          // console.log("Check6====>>>", JSON.parse(clientsDescryption));
          let concatAssetName = "";
          let totalAmountInBTC = 0;
          let totalAmountInUSD = 0;
          let transactionHistory = [];
          let assetBalance = [];
          let teampArray = [];

          mainClients.map((d, mainKey) => {
            console.log("hey=====", d?.Transactions?.length);
            d.Balance.map((t, key) => {
              console.log("t=========", t);
              let asset = t?.asset?.ticker?.split("/");
              if (asset[1]) {
                asset = asset[1];
              } else {
                asset = asset[0];
              }

              concatAssetName = concatAssetName + asset + ",";
              // console.log("TICKER", asset, t.amount.amount());
            });
            d.Transactions.txs.map(async (t, key) => {
              let apiRes = await axios.get(
                `${SERVER_URL_MAIN}/get/transaction/status/${t?.hash}`
              );

              let apiData = apiRes?.data;
              if (Number(apiData.count) > 0) {
                t.status = apiData?.actions[0]?.type;
              } else {
                t.status = "Deposit";
              }
              console.log("HEY CHECK HERE======", apiData);

              // apiData?.actions[0]?.out[0]?.coins[0]?.amount)

              if (t.asset.chain.toLowerCase() === "btc") {
                let res;
                if (Number(apiData.count) > 0) {
                  if (
                    (await gettingAssetName(
                      apiData?.actions[0]?.out[0]?.coins[0]?.asset.toLowerCase()
                    )) === "btc"
                  ) {
                    res =
                      Number(apiData?.actions[0]?.out[0]?.coins[0]?.amount) /
                      Math.pow(10, Number(t?.to[0]?.amount?.decimal));
                  } else {
                    res =
                      Number(apiData?.actions[0]?.in[0]?.coins[0]?.amount) /
                      Math.pow(10, Number(t?.to[0]?.amount?.decimal));
                  }
                  // res =
                  //   Number(apiData?.actions[0]?.out[0]?.coins[0]?.amount) /
                  //   Math.pow(10, Number(t?.to[0]?.amount?.decimal));
                  t.transferAmount = res;
                  transactionHistory.push(t);
                }

                // else {
                //   if (t?.to?.length > 1) {
                //     res =
                //       Number(t?.to[1]?.amount?.amount()?.c[0]) /
                //       Math.pow(10, Number(t?.to[1]?.amount?.decimal));
                //   } else {
                //     res =
                //       Number(t?.to[0]?.amount?.amount()?.c[0]) /
                //       Math.pow(10, Number(t?.to[0]?.amount?.decimal));
                //   }
                // }
              } else {
                let res;
                if (t?.to?.length > 1) {
                  res =
                    Number(t?.to[1]?.amount?.amount()?.c[0]) /
                    Math.pow(10, Number(t?.to[1]?.amount?.decimal));
                } else {
                  res =
                    Number(t?.to[0]?.amount?.amount()?.c[0]) /
                    Math.pow(10, Number(t?.to[0]?.amount?.decimal));
                }

                t.transferAmount = res;
                transactionHistory.push(t);
              }
            });
          });
          let apiDataBTC = await axios.get(
            `https://min-api.cryptocompare.com/data/price?fsym=BTC&tsyms=${concatAssetName}&api_key=${CRYPTOCOMPARE_KEY}`
          );
          let apiDataUSD = await axios.get(
            `https://min-api.cryptocompare.com/data/price?fsym=USD&tsyms=${concatAssetName}&api_key=${CRYPTOCOMPARE_KEY}`
          );
          let dataBTC = apiDataBTC.data;
          let dataUSD = apiDataUSD.data;
          console.log("DATA IN USD==========>>", dataUSD);
          mainClients.map((d, mainKey) => {
            d.Balance.map((t, key) => {
              let asset = t?.asset?.ticker?.split("/");
              if (asset[1]) {
                asset = asset[1];
              } else {
                asset = asset[0];
              }

              let existOrNot = midgardPool.find((d) => d.asset === asset);
              if (existOrNot || asset === "RUNE") {
                // console.log("heyData=====>>",asset, data[asset]);
                let value =
                  Number(t.amount.amount().c[0]) /
                  Math.pow(10, Number(t.amount.decimal));
                if (isNaN(value)) {
                  value = 0;
                }
                // totalAmountInBTC = totalAmountInBTC + value;
                // console.log("Value Before", asset, value);
                console.log("dataUSD=====>>", dataUSD);
                let valueBTC = value / dataBTC[asset];
                let valueUSD = value / dataUSD[asset];
                t.balanceUSD = valueUSD;
                t.marketPriceUSD = 1 / dataUSD[asset];
                totalAmountInUSD = totalAmountInUSD + valueUSD;
                totalAmountInBTC = totalAmountInBTC + valueBTC;
                assetBalance.push(t);
              }
            });
          });
          // .then((res) => {
          // })
          // .catch((err) => {
          //   alertToast(true, "CryptoCompare: Failed");
          // });
          console.log(
            "TOTAL AMOUNTBTC======>>>",
            totalAmountInBTC,
            CRYPTOCOMPARE_KEY
          );
          console.log("TOTAL AMOUNTUSD======>>>", totalAmountInUSD);
          console.log("mainClients======>>>", mainClients);
          setConnectKeyStoreModal(false);
          alertToast(false, "KeyStore Connected Successfully!");
          dispatch({
            type: KEYSTORECONNECTION_SUCCESS,
            payload: {
              KeyStoreClient: mainClients,
              overallBalance_USD: totalAmountInUSD,
              overallBalance_BTC: totalAmountInBTC,
              assetBalance: assetBalance,
              transactionHistory: transactionHistory,
              clientsObject: clientsObject,
              isLoggedin: true,
              walletType: "KEYSTORE",
              walletAddress: addressEth,
            },
          });
          setLoading(false);

          // Start getLiquidityAdditionPools

          dispatch({
            type: GETLIQUIDITY_REQUEST,
          });

          let liquidityAdded = [];
          try {
            let apiRes = await axios.get(
              // `${SERVER_URL_MAIN}/get/pools/against/client/${thorchainAddress}`
              `${SERVER_URL_MAIN}/get/pools/against/client/${thorAddress}`
            );
            liquidityAdded = apiRes?.data?.pools;
          } catch (error) {
            console.log("error============", error);
          }

          dispatch({
            type: GETLIQUIDITY_SUCCESS,
            payload: {
              liquidityAdded: liquidityAdded,
            },
          });

          // END getLiquidityAdditionPools

          //PolkaDot Client is setup here
          //  const userPolkaDotClient = new PolkadotClient({
          //    network:'testnet',
          //    phrase:res
          //  });
          //  console.log("User PolkaDot Client: ---------------> ", userPolkaDotClient.getAddress());
        } catch (e) {
          // console.log("ERR<><><><>< ", e);
          alertToast(e?.message || e);
          setLoading(false);
        }
      };
      fileReader = new FileReader();
      fileReader.onloadend = handleFileRead;
      fileReader.readAsText(fileKeyStore);
    } catch (error) {
      alertToast(true, error?.message || "Something went wrong");
      setLoading(false);
      setConnectKeyStoreModal(false);
    }
  };
  async function ethereumMemoConversion(data) {
    let arr = [];
    for (let i = 0; i < data.length; i++) {
      arr.push(data.charCodeAt(i).toString(16));
    }
    return arr.join("");
  }

  // Add Liquidity
  this.addLiquidity = async function (
    dispatch,
    fromAsset,
    toAsset,
    amount,
    decimal,
    midgardPool,
    setYayModal,
    setConfirmModal,
    setTransactionHash,
    setStatusLink,
    setLoading,
    memoSlip
  ) {
    console.log("from=======>>>", fromAsset.rawData.toString());
    console.log("to=======>>", toAsset, amount, decimal);
    setLoading(true);
    let walletAddressTo;
    let walletAddressFrom;
    let hash;
    dispatch({
      type: SWAPPING_REQUEST,
    });
    switch (fromAsset?.blockchain) {
      case "ETH":
        walletAddressFrom = userEthereumClient.getAddress();

        break;
      case "BNB":
        walletAddressFrom = userBinanceClient.getAddress();
        break;

      case "BTC":
        walletAddressFrom = userBtcClient.getAddress();

        break;

      case "LTC":
        walletAddressFrom = userLtcClient.getAddress();

        break;

      case "BCH":
        walletAddressFrom = userbchClient.getAddress();

        break;

      case "THOR":
        walletAddressFrom = userThorchainClient.getAddress();

        break;

      default:
        break;
    }

    switch (toAsset?.blockchain) {
      case "ETH":
        walletAddressTo = userEthereumClient.getAddress();

        break;
      case "BNB":
        walletAddressTo = userBinanceClient.getAddress();
        break;

      case "BTC":
        walletAddressTo = userBtcClient.getAddress();

        break;

      case "LTC":
        walletAddressTo = userLtcClient.getAddress();

        break;

      case "BCH":
        walletAddressTo = userbchClient.getAddress();

        break;

      case "THOR":
        walletAddressTo = userThorchainClient.getAddress();

        break;

      default:
        break;
    }

    try {
      let inboundAddress;
      if (fromAsset?.blockchain === "THOR") {
        inboundAddress = "tthor1mrckazz7l67tz435dp9m3qaygzm6xmsqeglrj8";
      } else {
        let inboundApi = await axios.get(INBOUND_ADDRESSES);
        inboundApi = inboundApi.data;
        inboundAddress = inboundApi.find(
          (data) => data.chain === fromAsset?.blockchain
        );
      }
      //  const Memo = "=:THOR.RUNE:tthor1fcaf3n4h34ls3cu4euwl6f7kex0kpctkf5p8d7";

      const Memo = `+:${toAsset?.rawData}:${walletAddressTo}:tthor12ctu8edzmpkcww68hu5dh4p8a9gsqc3wmw7ztz:100`;

      const send_amount = Number(amount) * Number(Math.pow(10, decimal));
      console.log("send Amount===>>", send_amount);
      let viewblock;
      let data;
      let apiCall;
      let response;
      switch (fromAsset?.blockchain) {
        case "ETH":
          // let conversion = await ethereumMemoConversion(Memo.toString());

          response = await ethUtilsService.callDeposit({
            inboundAddress: inboundAddress,
            asset: assetFromString(fromAsset.rawData),
            amount: Number(amount * 10 ** decimal),
            // amount: assetToBase(assetAmount(amount, decimal)).amount(),
            memo: Memo,
            ethClient: userEthereumClient,
          });
          response = response.split("x");
          response = response[1];
          const etherScan = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;
          setStatusLink(etherScan);
          setTransactionHash(response);
          setLoading(false);
          setConfirmModal(false);
          setYayModal(true);
          data = {
            coin: toAsset?.asset,
            amount: amount.toString(),
            address: walletAddressTo.toString(), //to
            transactionId: response.toString(),
            date: new Date().toString(),
            client: walletAddressFrom.toString(), //from,
            network: environment.network.toString(),
          };
          apiCall = await axios.post(
            `${SERVER_URL_MAIN}/add/transaction`,
            data
          );
          console.log("apiCall==============", apiCall);

          break;

        case "BNB":
          // console.log("InboundAddress====>>", inboundAddress);
          // console.log("InboundAddress====>>", fromAsset.rawData);
          // console.log("InboundAddress====>>", send_amount);
          // console.log("InboundAddress====>>", Memo);
          console.log("Hey BNB");
          response = await userBinanceClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          setStatusLink(viewblock);
          setTransactionHash(response);
          setLoading(false);
          setConfirmModal(false);
          setYayModal(true);
          data = {
            coin: toAsset?.asset,
            amount: amount.toString(),
            address: walletAddressTo.toString(), //to
            transactionId: response.toString(),
            date: new Date().toString(),
            client: walletAddressFrom.toString(), //from,
            network: environment.network.toString(),
          };
          apiCall = await axios.post(
            `${SERVER_URL_MAIN}/add/transaction`,
            data
          );
          console.log("apiCall==============", apiCall);

          console.log("response=====>>", viewblock);

          break;

        case "BTC":
          console.log("Hey BTC");
          response = await userBtcClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;
          setStatusLink(viewblock);
          setTransactionHash(response);
          setLoading(false);
          setConfirmModal(false);
          setYayModal(true);
          data = {
            coin: toAsset?.asset,
            amount: amount.toString(),
            address: walletAddressTo.toString(), //to
            transactionId: response.toString(),
            date: new Date().toString(),
            client: walletAddressFrom.toString(), //from,
            network: environment.network.toString(),
          };
          apiCall = await axios.post(
            `${SERVER_URL_MAIN}/add/transaction`,
            data
          );
          console.log("apiCall==============", apiCall);

          break;

        case "LTC":
          console.log("Hey LTC");
          response = await userLtcClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;
          setStatusLink(viewblock);
          setTransactionHash(response);
          setLoading(false);
          setConfirmModal(false);
          setYayModal(true);
          data = {
            coin: toAsset?.asset,
            amount: amount.toString(),
            address: walletAddressTo.toString(), //to
            transactionId: response.toString(),
            date: new Date().toString(),
            client: walletAddressFrom.toString(), //from,
            network: environment.network.toString(),
          };
          apiCall = await axios.post(
            `${SERVER_URL_MAIN}/add/transaction`,
            data
          );
          console.log("response=====>>", response);

          break;

        case "BCH":
          console.log("Hey BTC");
          response = await userbchClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;
          setStatusLink(viewblock);
          setTransactionHash(response);
          setLoading(false);
          setConfirmModal(false);
          setYayModal(true);
          data = {
            coin: toAsset?.asset,
            amount: amount.toString(),
            address: walletAddressTo.toString(), //to
            transactionId: response.toString(),
            date: new Date().toString(),
            client: walletAddressFrom.toString(), //from,
            network: environment.network.toString(),
          };
          apiCall = await axios.post(
            `${SERVER_URL_MAIN}/add/transaction`,
            data
          );
          console.log("apiCall==============", apiCall);
          console.log("response=====>>", response);

          break;

        case "THOR":
          console.log("Hey THOR");
          console.log("inound=====>>", inboundAddress);
          response = await userThorchainClient.deposit({
            // recipient: "",
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;
          setStatusLink(viewblock);
          setTransactionHash(response);
          setLoading(false);
          setConfirmModal(false);
          setYayModal(true);
          data = {
            coin: toAsset?.asset,
            amount: amount.toString(),
            address: walletAddressTo.toString(), //to
            transactionId: response.toString(),
            date: new Date().toString(),
            client: walletAddressFrom.toString(), //from,
            network: environment.network.toString(),
          };
          apiCall = await axios.post(
            `${SERVER_URL_MAIN}/add/transaction`,
            data
          );
          console.log("apiCall==============", apiCall);
          console.log("response=====>>", response);

          break;

        default:
          break;
      }
      dispatch({
        type: ADDLIQUIDITY_SUCCESS,
        payload: {
          transactionHash: response,
          transactionHistoryModal: true,
        },
      });

      console.log("Hey Response======", response);
    } catch (error) {
      console.log("error", error);
      alertToast(true, error?.message || error);
      setLoading(false);
    }
  };

  // Swapping
  this.nativeSwapping = async function (
    dispatch,
    fromAsset,
    toAsset,
    amount,
    toAmount,
    decimal,
    midgardPool,
    setYayModal,
    setConfirmModal,
    setTransactionHash,
    setStatusLink,
    setLoading,
    memoSlip
  ) {
    console.log("from=======>>>", fromAsset.rawData.toString());
    console.log("to=======>>", toAsset, amount, decimal);
    setLoading(true);
    let walletAddressTo;
    let walletAddressFrom;
    let hash;
    dispatch({
      type: SWAPPING_REQUEST,
    });
    switch (fromAsset?.blockchain) {
      case "ETH":
        walletAddressFrom = userEthereumClient.getAddress();

        break;
      case "BNB":
        walletAddressFrom = userBinanceClient.getAddress();
        break;

      case "BTC":
        walletAddressFrom = userBtcClient.getAddress();

        break;

      case "LTC":
        walletAddressFrom = userLtcClient.getAddress();

        break;

      case "BCH":
        walletAddressFrom = userbchClient.getAddress();

        break;

      case "THOR":
        walletAddressFrom = userThorchainClient.getAddress();

        break;

      default:
        break;
    }

    switch (toAsset?.blockchain) {
      case "ETH":
        walletAddressTo = userEthereumClient.getAddress();

        break;
      case "BNB":
        walletAddressTo = userBinanceClient.getAddress();
        break;

      case "BTC":
        walletAddressTo = userBtcClient.getAddress();

        break;

      case "LTC":
        walletAddressTo = userLtcClient.getAddress();

        break;

      case "BCH":
        walletAddressTo = userbchClient.getAddress();

        break;

      case "THOR":
        walletAddressTo = userThorchainClient.getAddress();

        break;

      default:
        break;
    }

    try {
      let inboundAddress;
      if (fromAsset?.blockchain === "THOR") {
        inboundAddress = "tthor1mrckazz7l67tz435dp9m3qaygzm6xmsqeglrj8";
      } else {
        let inboundApi = await axios.get(INBOUND_ADDRESSES);
        inboundApi = inboundApi.data;
        inboundAddress = inboundApi.find(
          (data) => data.chain === fromAsset?.blockchain
        );
      }
      //  const Memo = "=:THOR.RUNE:tthor1fcaf3n4h34ls3cu4euwl6f7kex0kpctkf5p8d7";

      const Memo = `=:${toAsset?.rawData}:${walletAddressTo}:${memoSlip}:tthor12ctu8edzmpkcww68hu5dh4p8a9gsqc3wmw7ztz:100`;

      const send_amount = Number(amount) * Number(Math.pow(10, decimal));
      console.log("send Amount===>>", send_amount);
      let viewblock;
      let data;
      let apiCall;
      let response;
      switch (fromAsset?.blockchain) {
        case "ETH":
          // let conversion = await ethereumMemoConversion(Memo.toString());

          response = await ethUtilsService.callDeposit({
            inboundAddress: inboundAddress,
            asset: assetFromString(fromAsset.rawData),
            amount: Number(amount * 10 ** decimal),
            // amount: assetToBase(assetAmount(amount, decimal)).amount(),
            memo: Memo,
            ethClient: userEthereumClient,
          });
          response = response.split("x");
          response = response[1];
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          break;

        case "BNB":
          // console.log("InboundAddress====>>", inboundAddress);
          // console.log("InboundAddress====>>", fromAsset.rawData);
          // console.log("InboundAddress====>>", send_amount);
          // console.log("InboundAddress====>>", Memo);
          console.log("Hey BNB");
          response = await userBinanceClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;
          break;

        case "BTC":
          console.log("Hey BTC");
          response = await userBtcClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          break;

        case "LTC":
          console.log("Hey LTC");
          response = await userLtcClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          break;

        case "BCH":
          console.log("Hey BTC");
          response = await userbchClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          break;

        case "THOR":
          console.log("Hey THOR");
          console.log("inound=====>>", inboundAddress);
          response = await userThorchainClient.deposit({
            // recipient: "",
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          break;

        default:
          break;
      }

      setStatusLink(viewblock);
      setTransactionHash(response);
      setLoading(false);
      setConfirmModal(false);
      setYayModal(true);
      data = {
        coin: toAsset?.asset,
        amount: toAmount.toString(),
        address: walletAddressTo.toString(), //to
        transactionId: response.toString(),
        date: new Date().toString(),
        client: walletAddressFrom.toString(), //from,
        network: environment.network.toString(),
      };
      apiCall = await axios.post(`${SERVER_URL_MAIN}/add/transaction`, data);
      console.log("apiCall==============", apiCall);
      let swappingData = {
        type: "Swap",
        fromAmount: amount,
        fromAsset: fromAsset,
        toAmount: toAmount,
        toAsset: toAsset,
        viewblock: viewblock,
      };
      dispatch({
        type: SWAPPING_SUCCESS,
        payload: {
          transactionHash: response,
          transactionHistoryModal: true,
          swappingData: swappingData,
        },
      });

      console.log("Hey Response======", response);
    } catch (error) {
      console.log("error", error);
      alertToast(true, error?.message || error);
      setLoading(false);
    }
  };

  const swapBNBToRuneNative = async () => {
    const destAddress = userBinanceClient.getAddress();
    console.log(
      "User Binance Client: >>>>>>>>>>>>>>>>>>>>>>>>>---------------> ",
      destAddress
    );
    const to_address = "tbnb1gr3zze7zkz2x6p08qnl88rhd22vpypmafeplr7";
    const send_amount = baseAmount(100000, 6);
    const Memo = "=:THOR.RUNE:tthor1fcaf3n4h34ls3cu4euwl6f7kex0kpctkf5p8d7";

    // const memoCheck = `${swapping}:THOR.RUNE:${address}`
    //= swap
    //+ deposit
    // const assetString = assetFromString('BNB.BUSD-BD1');
    // console.log('assetString------------------------', assetString);
    //assetfromstring(bnb); 1*10^6 1000000 1000000 / 10^6=1
    const result = await userBinanceClient.transfer({
      asset: AssetBNB, // inBoundBNB address assetfromstring(BNB.BNB)
      amount: send_amount,
      recipient: to_address, //vault inbound address of the chain https://testnet.midgard.thorchain.info/v2/thorchain/inbound_addresses
      memo: Memo,
    });
    console.log("i am here =======================>", result);

    return result;
  };
}
